import { createContext } from 'react'
import { GridContainerProps } from './GridContainer';

export type GridContextProps = {
  onUpdateContentState: (grid: GridContainerProps) => void
  gridId: string
  userId?: string
}

export const GridContext = createContext<GridContextProps | null>(null)